import React from "react";
import AdminShell from "@/pages/admin/AdminShell";
import { ActivityLog } from "@/pages/admin/AdminDashboard";

export default function ActivityPage() {
  return <AdminShell><ActivityLog /></AdminShell>;
}
